import ProjectService from '@monorepo/old-web/js/services/ProjectService';
import { useQuery } from 'react-query';

const createKey = ({ projectId }: { projectId: string }) =>
  ['project-modules', projectId] as const;

const fetcher = (_: string, projectId: string) => {
  const projectService = new ProjectService();
  return projectService.getModules(projectId);
};

export function useProjectModules({ projectId }: { projectId?: string }) {
  const isEnabled = !!projectId;
  const config = { enabled: isEnabled };
  const key = isEnabled ? createKey({ projectId }) : undefined;
  const { data, ...queryInfo } = useQuery(key, fetcher, config);

  return {
    ...queryInfo,
    projectModules: data,
  };
}
